import script from "./downloadPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./downloadPanel.vue?vue&type=script&setup=true&lang=ts"

import "./downloadPanel.vue?vue&type=style&index=0&id=61716344&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61716344"]])

export default __exports__